import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const SystemFullIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23 0.25H15.67C15.26 0.25 14.92 0.59 14.92 1C14.92 1.41 15.26 1.75 15.67 1.75H21.37L15.36 7.76C15.12 8 15.12 8.4 15.36 8.64C15.6 8.88 16 8.88 16.24 8.64L22.25 2.63V8.33C22.25 8.74 22.59 9.08 23 9.08C23.41 9.08 23.75 8.74 23.75 8.33V1C23.75 0.59 23.41 0.25 23 0.25Z"
        fill={color}
      />
      <path
        d="M23 14.92C22.59 14.92 22.25 15.26 22.25 15.67V21.37L16.24 15.36C16 15.12 15.6 15.12 15.36 15.36C15.12 15.6 15.12 16 15.36 16.24L21.37 22.25H15.67C15.26 22.25 14.92 22.59 14.92 23C14.92 23.41 15.26 23.75 15.67 23.75H23C23.41 23.75 23.75 23.41 23.75 23V15.67C23.75 15.26 23.41 14.92 23 14.92Z"
        fill={color}
      />
      <path
        d="M8.33 22.25H2.63L8.64 16.24C8.88 16 8.88 15.6 8.64 15.36C8.4 15.12 8 15.12 7.76 15.36L1.75 21.37V15.67C1.75 15.26 1.41 14.92 1 14.92C0.59 14.92 0.25 15.26 0.25 15.67V23C0.25 23.41 0.59 23.75 1 23.75H8.33C8.74 23.75 9.08 23.41 9.08 23C9.08 22.59 8.74 22.25 8.33 22.25Z"
        fill={color}
      />
      <path
        d="M8.33 0.25H1C0.59 0.25 0.25 0.59 0.25 1V8.33C0.25 8.74 0.59 9.08 1 9.08C1.41 9.08 1.75 8.74 1.75 8.33V2.63L7.76 8.64C8 8.88 8.4 8.88 8.64 8.64C8.88 8.4 8.88 8 8.64 7.76L2.63 1.75H8.33C8.74 1.75 9.08 1.41 9.08 1C9.08 0.59 8.74 0.25 8.33 0.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

SystemFullIcon.displayName = 'SystemFullIcon';
